// store/slices/productSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
  productId: "",
  storeHasProducts: false,
  existingBulletpoints: [],
  existingAplusContent: [],
  existingProductImages: [],
  existingAPlusProductImages: [],
  existingProductImagesAnalysis: [],
  characteristicsData: [],
  interCharacteristicsData: [],
  completedTabs: ["Product List"],
  productAmazonId: "",
  imageUrl: "",
  storeCombineBp: [],
  generatedImagesInstructions: [],
  childProductsExist: [],
  vendorCode: null,
  sku: null,
  producType: null,
  isProductUrlAnalyzer: false,
  productTitleSeoKeywords: [],
  productDescriptionApi: null,
  productDescriptionScraped: null,
  genericKeywords: null,
  negativeCharacteristicsData: [],
};

const productSlice = createSlice({
  name: "productSlice",
  initialState,
  reducers: {
    setPoductName: (state, action) => {
      state.name = action.payload;
    },
    setIsUrlAnalyzerProduct: (state, action) => {
      state.isProductUrlAnalyzer = action.payload;
    },
    setPoductId: (state, action) => {
      state.productId = action.payload;
    },
    setExistingBulletPoints: (state, action) => {
      state.existingBulletpoints = action.payload.bulletpoints;
      state.existingAplusContent = action.payload.aplusContent;
    },
    setExistingProductImages: (state, action) => {
      state.existingProductImages = action.payload.images;
    },
    setExistingChildProducts: (state, action) => {
      state.childProductsExist = action.payload;
    },
    setProductTitleSeoKeywords: (state, action) => {
      state.productTitleSeoKeywords = action.payload;
    },
    setExistingAPlusProductImages: (state, action) => {
      state.existingAPlusProductImages = action.payload.images;
    },
    setExistingProductImagesAnalysis: (state, action) => {
      state.existingProductImagesAnalysis = action.payload.images;
    },
    setCharacteristicsData: (state, action) => {
      state.characteristicsData = action.payload;
    },
    setInterCharacteristicsData: (state, action) => {
      state.interCharacteristicsData = action.payload;
    },
    setProductAmazonId: (state, action) => {
      state.productAmazonId = action.payload;
    },
    setImageUrl: (state, action) => {
      state.imageUrl = action.payload;
    },
    setCombinedBulletPoints: (state, action) => {
      state.storeCombineBp = action.payload;
    },
    setGeneratedImagesInstructions: (state, action) => {
      state.generatedImagesInstructions = action.payload;
    },
    setProductVendorCode: (state, action) => {
      state.vendorCode = action.payload;
    },
    setProductSku: (state, action) => {
      state.sku = action.payload;
    },
    setProductType: (state, action) => {
      state.producType = action.payload;
    },
    setProductTitle: (state, action) => {
      state.name = action.payload;
    },
    setProductDescription: (state, action) => {
      state.productDescriptionApi = action.payload.api;
      state.productDescriptionScraped = action.payload.scraped;
    },
    setGenericKeywords: (state, action) => {
      state.genericKeywords = action.payload;
    },
    setNegativeCharacteristicsData: (state, action) => {
      state.negativeCharacteristicsData = action.payload;
    },
    reset: (state) => {
      state.name = "";
      state.existingBulletpoints = [];
      state.existingAplusContent = [];
      state.existingProductImages = [];
      state.existingAPlusProductImages = [];
      state.existingProductImagesAnalysis = [];
      state.productId = "";
      state.completedTabs = ["Product List"];
      state.characteristicsData = [];
      state.negativeCharacteristicsData = [];
      state.interCharacteristicsData = [];
      state.productAmazonId = "";
      state.imageUrl = "";
      state.storeCombineBp = [];
      state.generatedImagesInstructions = [];
      state.isProductUrlAnalyzer = false;
      state.childProductsExist = [];
      state.vendorCode = null
      state.sku = null;
      state.producType = null;
      state.productTitleSeoKeywords = [];
      state.productDescriptionApi = null;
      state.productDescriptionScraped = null;
      state.genericKeywords = null;
    },

    addCompletedTab: (state, action) => {
      if (!state.completedTabs.includes(action.payload)) {
        state.completedTabs.push(action.payload);
      }
    },
    removeCompletedTab: (state, action) => {
      state.completedTabs = state.completedTabs.filter(
        (tab) => tab !== action.payload
      );
    },
  },
});

export const {
  setPoductName,
  setExistingBulletPoints,
  setExistingProductImages,
  setExistingAPlusProductImages,
  setCharacteristicsData,
  addCompletedTab,
  reset,
  setPoductId,
  removeCompletedTab,
  setInterCharacteristicsData,
  setProductAmazonId,
  setImageUrl,
  setExistingChildProducts,
  setExistingProductImagesAnalysis,
  setCombinedBulletPoints,
  setGeneratedImagesInstructions,
  setIsUrlAnalyzerProduct,
  setProductVendorCode,
  setProductType,
  setProductSku,
  setProductTitleSeoKeywords,
  setProductTitle,
  setProductDescription,

  setGenericKeywords,
  setNegativeCharacteristicsData
} = productSlice.actions;
export default productSlice.reducer;
